export enum CustomPaymentMethodRouteEnum {
  MAIN = "custom-payment-methods.main",
}
